import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import SearchBarUpdated from '../../SearchBarUpdated';
import CategoriesSection from './CategoriesSection';

const HeroSection = ({ onSearchResults, categories, categoriesLoading, selectedCategoryId, onCategoryClick }) => {
  const { t } = useTranslation();
  const [topOffset, setTopOffset] = useState(120); // Navbar + bande de promotion par défaut

  useEffect(() => {
    // Calculer la hauteur totale de la navbar + bande de promotion
    const updateOffset = () => {
      const navbar = document.querySelector('nav') || document.querySelector('[class*="z-50"]');
      const banner = document.querySelector('[class*="z-40"][style*="top"]');

      let totalHeight = 80; // Hauteur navbar par défaut

      if (navbar) {
        totalHeight = navbar.offsetHeight;
      }

      if (banner) {
        totalHeight += banner.offsetHeight || 60; // Hauteur bande par défaut
      }

      setTopOffset(totalHeight);
    };

    updateOffset();
    window.addEventListener('resize', updateOffset);

    // Attendre que le DOM soit chargé
    setTimeout(updateOffset, 100);

    return () => window.removeEventListener('resize', updateOffset);
  }, []);

  return (
    <div
      className="relative left-1/2 right-1/2 -mx-[50vw] w-screen"
      style={{ position: 'relative', background: '#FBF9D9', overflow: 'hidden', paddingTop: `${topOffset + 30}px` }}
    >
      <div style={{ position: 'absolute', right: '-140px', top: '-180px', width: '420px', height: '420px', borderRadius: '999px', background: '#72B744', opacity: 0.18 }}></div>
      <div style={{ position: 'absolute', left: '-90px', bottom: '-130px', width: '260px', height: '260px', borderRadius: '999px', background: '#EF4C23', opacity: 0.1 }}></div>

      <div
        style={{
          position: 'relative',
          maxWidth: '1000px',
          margin: '0 auto',
          padding: 'clamp(32px, 5vw, 64px) clamp(20px, 5vw, 40px) clamp(40px, 6vw, 72px)',
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '22px',
        }}
      >
        <h1
          className="animate-fade-in"
          style={{
            margin: 0,
            fontFamily: 'Fraunces, Georgia, serif',
            fontWeight: 900,
            fontSize: 'clamp(32px, 6vw, 78px)',
            lineHeight: 0.98,
            letterSpacing: '-0.025em',
            maxWidth: '20ch',
            color: '#051004',
          }}
        >
          {t('home.hero.title')}
        </h1>

        <p
          className="animate-fade-in-delay"
          style={{
            margin: 0,
            fontSize: 'clamp(15px, 1.4vw, 20px)',
            lineHeight: 1.6,
            maxWidth: '46ch',
            color: 'rgba(5,16,4,0.76)',
          }}
        >
          {t('home.hero.subtitle')}
        </p>

        {/* Search Bar in Hero - z-index bas pour laisser le dropdown de la navbar passer au-dessus */}
        <div
          className="animate-fade-in-delay-2"
          style={{ width: '100%', maxWidth: '720px', position: 'relative', zIndex: 10 }}
        >
          <SearchBarUpdated onSearchResults={onSearchResults} />
        </div>

        {/* Categories Section just below search bar */}
        <div className="animate-fade-in-delay-2" style={{ width: '100%' }}>
          <CategoriesSection
            categories={categories}
            categoriesLoading={categoriesLoading}
            selectedCategoryId={selectedCategoryId}
            onCategoryClick={onCategoryClick}
          />
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
